export const required =
  (msg = "필수 항목입니다.") =>
  (v) =>
    (v !== null && v !== undefined && String(v).trim() !== "") || msg;

export const minLen =
  (n, msg = `${n}자 이상 입력해주세요`) =>
  (v) =>
    String(v || "").length >= n || msg;

export const email =
  (msg = "이메일 형식이 올바르지 않습니다.") =>
  (v) =>
    !String(v || "").trim() || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || msg;
